<template>
  <div class="_modals">
    <div class="vouchers__exchange">
      <div class="vouchers__exchange--modals">
        <b-modal id="img-voucher"
                 ref="imgvoucher"
                 @hidden="resetModalVoucher"
                 centered
                 hide-footer>
          <img class="voucher" :src="getImagaVoucher(voucherData.name)">
          <div class="detailreedem">
            <div class="detailreedem__iconpoint">
              <p class="">AndalinPoints Balance:</p>
              <div class="row m-0 mt-2 justify-content-center">
                <img height="17px" src="@/assets/image/image/andalin-point.png">
                <h5>{{ voucherData.currentPoint | currency('', 0, { spaceBetweenAmountAndSymbol: true })}} AndalinPoints</h5>
              </div>
            </div>
            <form class="mt-3" @submit.prevent="reedemPoint">
              <div v-if="voucherData.group === 'voucher'">
                <div class="mt-3">
                  <p class="fontstyle__default mb-1">Choose Your Voucher Type </p>
                  <div class="options__multipleselect">
                    <multiselect
                      name="voucher type"
                      v-validate="'required'"
                      :state="errors.first('voucher type') && false"
                      v-model="voucherPayload.voucher"
                      :options="OptionTopUp"
                      placeholder="Select"
                      selectedLabel=""
                      label="text"
                      :select-label="''" :deselect-label="''"
                      >
                      <span slot="noResult">Oops! No elements found.</span>
                    </multiselect>
                  </div>
                  <p v-if="errors.has('voucher type')" class="fontstyle__errormsg">
                        {{ errors.first('voucher type') }}
                  </p>
                </div>
                <div class="mt-3 input__model1group">
                  <p class="fontstyle__default mb-1">Phone Number</p>
                  <div class="row m-0 detailreedem__phone">
                    <p class="mr-1">+62</p>
                    <b-form-input
                      class="col-md"
                      name="phone number"
                      v-validate="'required'"
                      :state="errors.first('phone number') && false"
                      type="number"
                      :placeholder="`${voucherPayload.voucher ? voucherPayload.voucher.text : 'OVO/Gopay'} Phone Number`"
                      v-model="voucherPayload.phoneNumber"
                    />
                  </div>
                  <p v-if="errors.has('phone number')" class="fontstyle__errormsg">
                      {{ errors.first('phone number') }}
                  </p>
                </div>
                <div class="mt-3 input__model1group">
                  <p class="fontstyle__default mb-1">
                    {{ voucherPayload.voucher ? voucherPayload.voucher.text : 'OVO/Gopay'}} Username
                  </p>
                  <b-form-input
                    name="username"
                    v-validate="'required'"
                    :state="errors.first('username') && false"
                    type="text"
                    placeholder="Username"
                    v-model="voucherPayload.username"
                  />
                  <p v-if="errors.has('username')" class="fontstyle__errormsg">
                        {{ errors.first('username') }}
                  </p>
                </div>
              </div>

              <div v-if="voucherData.group === 'e-voucer'">
                <div class="mt-3 input__model1group">
                  <p class="fontstyle__default mb-1">
                    Your Email Address
                  </p>
                  <b-form-input
                    name="email"
                    v-validate="'email'"
                    :state="errors.first('email') && false"
                    type="text"
                    placeholder="Email"
                    v-model="voucherPayload.username"
                  />
                  <p v-if="errors.has('email')" class="fontstyle__errormsg">
                        {{ errors.first('email') }}
                  </p>
                </div>
                <div class="mt-3 input__model1group">
                  <p class="fontstyle__default mb-1">Your Phone Number</p>
                  <div class="row m-0 detailreedem__phone">
                    <b-form-input
                      class="col-md"
                      name="phone number"
                      v-validate="'required'"
                      :state="errors.first('phone number') && false"
                      type="number"
                      placeholder="Phone Number"
                      v-model="voucherPayload.phoneNumber"
                    />
                  </div>
                  <p v-if="errors.has('phone number')" class="fontstyle__errormsg">
                      {{ errors.first('phone number') }}
                  </p>
                </div>
              </div>

              <div v-if="voucherData.group === 'voucher'" class="detailreedem__info">
                <p>Redeem your special redeem voucher and top up your OVO or Gopay balance:</p>
                <ul class="mt-2">
                  <li>Once redeemed, you will get {{ voucherData.voucherIDRtext }} top up balance for selected platform.</li>
                  <li>Top Up process will take within 3-7 working days.</li>
                  <li>This voucher cannot be exchange for cash or any other items.</li>
                </ul>
              </div>

              <div v-if="voucherData.group === 'e-voucer'">
                <div class="detailreedem__info">
                  <p>Redeem your Andalin Points and get shipment discount e-voucher:</p>
                  <ol class="mt-2">
                    <li>Once redeemed, you will get {{ voucherData.voucherIDRtext }} shipment discount e-voucher</li>
                    <li>Redeem process will take within 3-7 working days.</li>
                    <li>E-Voucher cannot be exchange for cash or any other items.</li>
                    <li>E-Voucher only can be used for your shipping in Andalin.</li>
                    <li>E-Voucher details will be send to your email.</li>
                  </ol>
                </div>
              </div>

              <div class="text-center mt-4">
                <p v-if="!statusRedeem"
                  class="fontstyle__errormsg pb-2">
                  You have insufficient AndalinPoints to  exchange with this voucher.
                </p>
                <button v-else :disabled="!statusRedeem || isLoadingredeemPoint"
                        class="button__bluecorporite"
                        name="submit" type="submit">
                  <span  v-if="isLoadingredeemPoint">
                    <b-spinner small variant="light" label="Spinning" />
                  </span>
                  <span v-else>Redeem Point</span>
                </button>
              </div>
            </form>
          </div>
        </b-modal>
      </div>
    </div>

    <div id="point__saved">
      <b-modal ref="modalPointSaved"
           centered
           hide-footer
           title="">
        <div class="modal__contain">
          <div class="text-center">
            <img src="@/assets/image/icon/reedem-success.svg" alt="">
            <p class="pt-3">Redeem coupon success !</p>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      statusRedeem: true,
      voucherData: {},
      voucherPayload: {
        voucher: '',
        point: null,
        merchant: '',
        phoneNumber: '',
        username: '',
        email: ''
      },
      buttons: [
        { id: 1, text: 'MAP', value: 'MAP' },
        { id: 2, text: 'Transmart Carrefour', value: 'Transmart Carrefour' },
        { id: 3, text: 'Boga Group', value: 'Boga Group' }
      ],
      OptionTopUp: [
        { id: 1, text: 'OVO', value: 'OVO' },
        { id: 2, text: 'Gopay', value: 'Gopay' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      redeemPoint: 'andalinpoint/redeemPoint',
      isLoadingredeemPoint: 'andalinpoint/isLoadingredeemPoint',
      errorredeemPoint: 'andalinpoint/errorredeemPoint'
    })
  },
  created () {
    this.$eventHub.$on('dialog-voucher-img', this.dialogVoucher)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-voucher-img')
  },
  mounted () {
  },
  methods: {
    resetModalVoucher () {
      this.voucherData = {}
      this.statusRedeem = true
      this.voucherPayload = {
        voucher: '',
        merchant: '',
        phoneNumber: '',
        username: ''
      }
    },
    closeModal () {
      this.$refs.modalPointSaved.hide()
    },
    dialogVoucher (item) {
      this.voucherData = item
      if (parseInt(item.currentPoint) < parseInt(item.redeemPoint)) {
        this.statusRedeem = false
      } else {
        this.statusRedeem = true
      }
      this.$refs.imgvoucher.show()
    },
    removeZeroFirstChar (phoneString) {
      let str = phoneString.toString()
      if (phoneString) {
        if (str.charAt(0) === '0') {
          str = str.substring(1) // remove first character
        }
      }
      return `+62${str}`
    },

    async reedemPoint () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const payload = {
            voucher_amount: this.voucherData.voucherIDRtext.toString(),
            point_amount: this.voucherData.redeemPoint.toString(),
            merchant: this.voucherPayload.voucher ? this.voucherPayload.voucher.text : 'Shipment Discount',
            username: this.voucherPayload.username,
            phoneNumber: this.voucherPayload.phoneNumber ? this.removeZeroFirstChar(this.voucherPayload.phoneNumber) : ''
          }
          // console.log(payload)
          this.postPayload(payload)
        }
      })
    },
    async postPayload (payload) {
      await this.$store.dispatch('andalinpoint/POST_POINT_REDEEM', payload)
      await this.cekSuccessRedeem()
      if (this.errorredeemPoint) {
        console.log('Internal Error: ', this.errorredeemPoint)
      }
    },
    cekSuccessRedeem () {
      return new Promise((resolve) => {
        if (this.redeemPoint) {
          this.$refs.modalPointSaved.show()
          this.$refs.imgvoucher.hide()
          return resolve()
        }
      })
    },
    getImagaVoucher (type) {
      if (type === 'vouncher-1' || type === 'vouncher-5') {
        return require('@/assets/image/image/ap-voucher-100.png')
      } else if (type === 'vouncher-2' || type === 'vouncher-6') {
        return require('@/assets/image/image/ap-voucher-300.png')
      } else if (type === 'vouncher-3' || type === 'vouncher-7') {
        return require('@/assets/image/image/ap-voucher-1000.png')
      } else if (type === 'e-2juta' || type === 'vouncher-7') {
        return require('@/assets/image/image/Shipmet Disc Voucher 2jt.png')
      } else if (type === 'e-600' || type === 'vouncher-7') {
        return require('@/assets/image/image/Shipmet Disc Voucher 600 Ribu.png')
      } else if (type === 'e-200' || type === 'vouncher-7') {
        return require('@/assets/image/image/Shipmet Disc Voucher 200 Ribu.png')
      }
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/Andalinpoint.vue